import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  nb: {
    errorMessage: {
      supportLinkLabel: 'Kontakt brukerstøtte',
      retryButton: 'Prøv på nytt',
      goBackButton: 'Gå tilbake',
      goToLoginButton: 'Gå til innlogging',
      defaultTitle: 'Det oppstod en feil',
      defaultTitleWithStatus: 'Det oppstod en feil (status {{status}})',
      defaultContent:
        'Vennligst prøv igjen senere. Vedvarer problemet? <supportLink>Kontakt brukerstøtte</supportLink>',
      networkTitle: 'Klarte ikke å kontakte serveren',
      networkContent:
        'Sjekk at du har nettverkstilgang og at tjenesten er tilgjengelig. Vedvarer problemet? <supportLink>Kontakt brukerstøtte</supportLink>',
      authTitle: 'Du må logge inn på nytt',
      authContent:
        'Du er ikke logget inn eller mangler tilgang. Prøv å logge inn på nytt.',
      forbiddenTitle: 'Du har ikke tilgang til dette innholdet',
      forbiddenContent:
        'Du mangler tilgang til dette innholdet. Hvis du mener dette er feil, kan du <supportLink>Kontakt brukerstøtte</supportLink>.',
      notFoundTitle: 'Innholdet finnes ikke',
      notFoundContent: 'Ressursen du forsøker å åpne finnes ikke.',
      conflictTitle: 'Noe ble endret samtidig',
      conflictContent:
        'Det du prøvde å endre ble oppdatert av noen andre mens du jobbet. Last siden på nytt og prøv igjen.',
      conflict409Title: 'Handlingen kunne ikke fullføres',
      conflict409Content:
        'Ressursen er i bruk eller finnes allerede, eller handlingen tillates ikke i nåværende tilstand. Prøv igjen senere, eller kontakt brukerstøtte hvis problemet vedvarer.',
      cameraTitle: 'Kunne ikke åpne kamera',
      cameraContent:
        'Sjekk at du har gitt dette nettstedet tillatelse til å bruke kameraet.',
      errorMessageLabel: 'Feilmelding: {{message}}',
      routeNotFoundTitle: 'Denne siden finnes ikke',
      routeNotFoundContent: 'Siden du prøver å besøke finnes ikke: {{path}}'
    }
  },
  en: {
    errorMessage: {
      supportLinkLabel: 'Contact support',
      retryButton: 'Try again',
      goBackButton: 'Go back',
      goToLoginButton: 'Go to login',
      defaultTitle: 'Something went wrong',
      defaultTitleWithStatus: 'Something went wrong (status {{status}})',
      defaultContent:
        'Please try again later. If the problem persists, contact support.',
      networkTitle: 'Unable to reach the server',
      networkContent:
        'Check your network connection and that the service is available. If the problem persists, contact support.',
      authTitle: 'You need to sign in again',
      authContent:
        'You are not signed in or do not have access. Please sign in again.',
      forbiddenTitle: 'You do not have access to this content',
      forbiddenContent:
        'You do not have access to this content. If you believe this is an error, contact support.',
      notFoundTitle: 'Content not found',
      notFoundContent: 'The resource you are trying to open was not found.',
      conflictTitle: 'Something was changed at the same time',
      conflictContent:
        'The content you tried to change was updated by someone else while you were working. Reload the page and try again.',
      conflict409Title: 'The action could not be completed',
      conflict409Content:
        'The resource is in use or already exists, or the action is not allowed in its current state. Try again later, or contact support if the problem persists.',
      cameraTitle: 'Unable to open the camera',
      cameraContent:
        'Check that you have given this site permission to use the camera.',
      errorMessageLabel: 'Error: {{message}}',
      routeNotFoundTitle: 'This page does not exist',
      routeNotFoundContent:
        'The page you are trying to visit does not exist: {{path}}'
    }
  }
} as const

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: 'nb',
    fallbackLng: 'nb',
    supportedLngs: ['nb', 'en'],
    interpolation: {
      escapeValue: false
    }
  })
}

export { i18n }
